<template>
    <div>
        <el-tabs>
            <el-tab-pane label="作品统计" name="" style="width: 100%;">
                <div id="chart" style="width:706px;height:320px;"></div>
            </el-tab-pane>
            <el-tab-pane label="任务趋势" style="width: 100%;">
                <div style="position: relative;">
                    <div class="inner-right">
                        <div class="block">
                            <el-date-picker
                                    @change="trendDataChange"
                                    :editable="false"
                                    :clearable="false"
                                    size="small"
                                    v-model="trendYear"
                                    type="year"
                                    placeholder="选择年"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </div>
                    <div id="trendChart" style="width:706px;height:320px;"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import echarts from 'echarts';
import axios from 'axios';

export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getFullYear() > (new Date()).getFullYear();
                }
            },
            currentData: {
                processingMaterialCount:0,
                finishedMaterialCount:0,
                materialCount:0
            },
            trendData: {
                taskCount:[],
                months:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],
                requirementCount:[]
            },
            trendYear: (new Date()).getFullYear().toString(),
            summerChart: null,
            trendChart: null
        }
    },
    beforeMount() {
        // 获取统计数据
        this.getSummerData();
        // 获取趋势数据
        this.getTrendData(this.trendYear);
    },
    mounted() {
        this.summerChart = echarts.init(document.getElementById('chart'));
        this.trendChart = echarts.init(document.getElementById('trendChart'));
        // 指定统计图表的配置项和数据
        var summerOption = {
            title: {
                text: '作品统计'
            },
            legend: {
                data: ['版权作品总数量', '录制中作品数量', '已完成作品数量'],
                bottom: '30px'
            },
            grid: {
                bottom: '80px'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'value',
                boundaryGap: false,
                axisLine: {
                    lineStyle: {
                        color: '#fc5832'
                    }
                }
            },
            yAxis: {
                type: 'category',
                data: ['作品统计'],
                axisLine: {
                    lineStyle: {
                        color: '#fc5832'
                    }
                }
            },
            series: [{
                name: '版权作品总数量',
                type: 'bar',
                barWidth: '30px',
                barGap: '40%',
                data: [this.currentData.materialCount],
                label: {
                    normal: {
                        show: true,
                        position: 'right'
                    }
                }
            },{
                name: '录制中作品数量',
                type: 'bar',
                barWidth: '30px',
                barGap: '40%',
                data: [this.currentData.processingMaterialCount],
                label: {
                    normal: {
                        show: true,
                        position: 'right'
                    }
                }
            },{
                name: '已完成作品数量',
                type: 'bar',
                barWidth: '30px',
                barGap: '40%',
                data: [this.currentData.finishedMaterialCount],
                label: {
                    normal: {
                        show: true,
                        position: 'right'
                    }
                }
            }]
        };
        // 指定任务趋势图标的配置项和数据
        var taskTrendOption = {
            title: {
                text: '任务趋势统计'
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                }
            },
            legend: {
                data: ['发布的任务', '录制的任务'],
                bottom: '30px'
            },
            grid: {
                bottom: '80px'
            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: {
                        alignWithLabel: true
                    },
                    data: this.trendData.months,
                    axisLine: {
                        lineStyle: {
                            color: '#fc5832'
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    name: '数量',
                    min: 0,
                    axisLine: {
                        lineStyle: {
                            color: '#fc5832'
                        }
                    }
                }
            ],
            series: [
                {
                    name:'发布的任务',
                    type:'line',
                    data:this.trendData.requirementCount
                },
                {
                    name:'录制的任务',
                    type:'line',
                    data:this.trendData.taskCount
                }
            ]
        };
        // 显示任务统计图表。
        this.summerChart.setOption(summerOption);
        // 显示趋势图标
        this.trendChart.setOption(taskTrendOption);
    },
    methods: {
        getSummerData() {
            const that = this;
            axios.get('/api/statics/report/material/count').then(res => {
                if (res.data.code === 200) {
                    that.currentData = res.data.data;
                    let summerData = [{
                        data: [that.currentData.materialCount]
                    },{
                        data: [that.currentData.processingMaterialCount],
                    },{
                        data: [that.currentData.finishedMaterialCount],
                    }];
                    that.refreshData(that.summerChart, summerData);
                } else {
                    that.$message({
                        type: 'warning',
                        message: res.data.message,
                        duration: 1500
                    });
                }
            });
        },
        getTrendData(year) {
            const that = this;
            axios.get(`/api/statics/report/requirement/count?year=${year}`).then(res => {
                if (res.data.code === 200) {
                    that.trendData = res.data.data;
                    let trendData = [{
                        data:that.trendData.requirementCount
                    }, {
                        data:that.trendData.taskCount
                    }];
                    that.refreshData(that.trendChart, trendData);
                } else {
                    that.$message({
                        type: 'warning',
                        message: res.data.message,
                        duration: 1500
                    });
                }
            });
        },
        trendDataChange(year) {
            this.getTrendData(year);
        },
        refreshData(chart, data) {
            chart.setOption({
                series: data
            })
        }
    }
}
</script>
<style lang="sass" scope>
    .inner-right {
        position: absolute;
        right: 70px;
        top: 5px;
        z-index: 999;
    }
</style>



// WEBPACK FOOTER //
// DataAnalysis.vue?335a3fde